import React from 'react'
import { Link } from 'react-router-dom'

import { StyledInternalBanner } from './StyledBanner'
import { T } from 'components/Translations'

const banners = [
  {
    name: 'uploadPhoto',
    condition: profile => profile.media[0].uri.match(/nophoto/), // No user image
    component: () => (
      <StyledInternalBanner>
        <T as="p" label="messages/uploadPhoto|basicHTML" />

        <T as={Link} to="/myprofile" label="actions/uploadPhoto" />
      </StyledInternalBanner>
    ),
  },
  {
    name: 'fillProfileInfo',
    condition: profile => !profile.aboutMe.length, // No profile info
    component: () => (
      <StyledInternalBanner>
        <T as="p" label="messages/fillYourInfo|basicHTML" />

        <T as={Link} to="/myprofile/matches" label="actions/completeYourProfile" />
      </StyledInternalBanner>
    ),
  },
  {
    name: 'useAdvancedSearch',
    condition: profile => !profile.gold, // User has not upgraded
    component: () => (
      <StyledInternalBanner>
        <T as="p" label="messages/unlockSearch|basicHTML" />

        <T as={Link} to="/find-date" label="sections/findADate" />
      </StyledInternalBanner>
    ),
  },
  {
    name: 'chat',
    condition: profile => !profile.gold, // User has not upgraded
    component: () => (
      <StyledInternalBanner>
        <T as="p" label="messages/chatWithSomeone|basicHTML" />

        <T as={Link} to="/find-date" label="actions/chatNow" />
      </StyledInternalBanner>
    ),
  },
  {
    name: 'VIP',
    condition: (profile, flags) => flags.vip && profile.gold && !profile.vip,
    component: () => (
      <StyledInternalBanner>
        <T as="p" label="messages/getVipStatus|basicHTML" />

        <T as={Link} to="/payment/upgrade" label="actions/getNoticed" />
      </StyledInternalBanner>
    ),
  },
]

export default banners
